export default __webpack_public_path__ + "static/media/img_Projet1.fd18874a.png";